<div>
	<progress-indicator
		[isStatic]="showProgressIndicator"
		[description]="Loc(LocalizedTextIds.Authenticating)"
	></progress-indicator>
</div>
